import { useQuery } from "react-query";

import { TR_SCENARIO_CACHE_KEYS } from "./cacheKeys";
import { fetchTrConfig, fetchTrScenarios } from "./callers";

export const useGetTrScenarios = (projectId?: string) =>
  useQuery(TR_SCENARIO_CACHE_KEYS.list(projectId), () => fetchTrScenarios(projectId as string), {
    enabled: Boolean(projectId),
  });

export const useGetTrConfig = (projectId?: string, configId?: number) =>
  useQuery(
    TR_SCENARIO_CACHE_KEYS.detail(projectId, configId),
    () => {
      if (!projectId || configId == null) throw new Error("Missing configuration");
      return fetchTrConfig(projectId, configId);
    },
    { enabled: Boolean(projectId) && configId != null }
  );
